import {createContext} from "react";

const SearchContext = createContext(undefined);
export default SearchContext;